import type { MealTotals } from "../api/diary";

export type DaySummaryProps = {
  totals: MealTotals | undefined;
  cardBg: string;
  hint: string;
  fg: string;
  kcalGoal?: number;
};

function fmt(n: number, digits = 2): string {
  if (!Number.isFinite(n)) return "0";
  return n.toFixed(digits).replace(".", ",");
}

export default function DaySummary({ totals, cardBg, hint, fg, kcalGoal = 2000 }: DaySummaryProps) {
  const t = totals ?? { kcal: 0, protein: 0, fat: 0, carbs: 0 };
  const rsk = Math.round((t.kcal / kcalGoal) * 100);

  const cells: { label: string; value: string; emphasized?: boolean }[] = [
    { label: "Жиры", value: fmt(t.fat) },
    { label: "Углев", value: fmt(t.carbs) },
    { label: "Белк", value: fmt(t.protein) },
    { label: "РСК", value: `${rsk}%` },
    { label: "Калории", value: String(Math.round(t.kcal)), emphasized: true },
  ];

  return (
    <div
      style={{
        margin: "0 8px",
        background: cardBg,
        borderRadius: 10,
        padding: "10px 12px",
        display: "grid",
        gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
        gap: 6,
        boxSizing: "border-box",
        minWidth: 0,
      }}
    >
      {cells.map((c) => (
        <div key={c.label} style={{ textAlign: "center", minWidth: 0 }}>
          <div
            style={{
              fontSize: c.emphasized ? 15 : 14,
              fontWeight: c.emphasized ? 700 : 600,
              color: fg,
              lineHeight: 1.2,
              fontVariantNumeric: "tabular-nums",
            }}
          >
            {c.value}
          </div>
          <div style={{ fontSize: 10, color: hint, marginTop: 2 }}>{c.label}</div>
        </div>
      ))}
    </div>
  );
}
